import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Dropdown } from "rsuite";
import DropdownItem from "rsuite/esm/Dropdown/DropdownItem";
import { SvgAccount } from "../../assets/icons";
import { AppRoutesUI } from "../../config/appRoutes";
import { useAppDispatch, useAppSelector } from "../../core/redux/reduxStore";
import { AuthActions } from "../../core/redux/slices/authSlice";
import { showSuccessToast } from "./toast.component";

export const UserDropDown = () => {
  const { userName, email, role } = useAppSelector((state) => state.auth);

  const [appUserName, setAppUserName] = useState<string>("");
  const [appUserEmail, setAppUserEmail] = useState<string>("");

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (userName !== undefined) setAppUserName(userName);
    if (email !== undefined) setAppUserEmail(email);
  }, [userName, email]);

  const handleLogOut = () => {
    window.localStorage.clear();
    dispatch(AuthActions.logout());
    showSuccessToast("LogOut is Successful");
  };

  return (
    <>
      <Dropdown
        title={appUserEmail}
        placement="bottomEnd"
        icon={<SvgAccount />}
      >
        <DropdownItem className="d-flex flex-column">
          <p className="fw-bold">{appUserName}</p>
        </DropdownItem>
        {role === "SuperAdmin" ? (
          <Link to={AppRoutesUI.SuperAdmin.SuperAdminProfile()}>
            <DropdownItem>Profile</DropdownItem>
          </Link>
        ) : role === "Admin" ? (
          <Link to={AppRoutesUI.Admins.AdminProfileView()}>
            <DropdownItem>Profile</DropdownItem>
          </Link>
        ) : (
          <Link to={AppRoutesUI.Users.UsersProfileView()}>
            <DropdownItem>Profile</DropdownItem>
          </Link>
        )}
        {role === "SuperAdmin" ? (
          <Link to={AppRoutesUI.SuperAdmin.SuperAdminChangePassword()}>
            <DropdownItem>Change Password</DropdownItem>
          </Link>
        ) : role === "Admin" ? (
          <Link to={AppRoutesUI.Admins.AdminChangePassword()}>
            <DropdownItem>Change Password</DropdownItem>
          </Link>
        ) : (
          ""
        )}
        <DropdownItem divider />
        <DropdownItem onClick={handleLogOut}>Sign Out</DropdownItem>
      </Dropdown>
    </>
  );
};
